<template>
  <div v-bind="$attrs" class="text-subtitle-2"><slot></slot></div>
</template>

<script>

export default {
  name: 'field-label',
};
</script>